// extracted by mini-css-extract-plugin
module.exports = {"gsapa":"deltapronew_gsapa__lQTXq"};